const initialPublishYear = 2022;
const currentPublishYear = Number(new Date().getFullYear());
let copyrightYear: string = `${initialPublishYear}`;

if (initialPublishYear === currentPublishYear) {
  copyrightYear = `${initialPublishYear}`;
} else {
  copyrightYear = `${initialPublishYear}-${currentPublishYear}`;
}

export const info = {
  appName: `Synapse Anywhere`,
  copyrightYear,
  companyName: `Zethcon Corporation`,
} as const;
